import type { TAddress } from '@backend/lib-l10n/address';

export interface AddressLocation {
  latitude: number;
  longitude: number;
}

export interface AddressWithNameAndLocation extends TAddress {
  name: string;
  label?: string;
  location?: AddressLocation;
}

export interface Prediction {
  id: string;
  address: string;
}

// the name parsed back from a search url is its slug: whatever shows the address reads the label first
export const getAddressDisplayName = ({ label, name }: AddressWithNameAndLocation) => label || name;

export const isSameLocation = (location?: AddressLocation, otherLocation?: AddressLocation) =>
  Boolean(
    location &&
    otherLocation &&
    location.latitude === otherLocation.latitude &&
    location.longitude === otherLocation.longitude,
  );

export const stringifyAddress = ({ name, zipcode, location }: AddressWithNameAndLocation): string =>
  `${[name, zipcode].filter(Boolean).join('+')}@${location?.latitude},${location?.longitude}`;

export const parseAddressParam = (address: string): AddressWithNameAndLocation | undefined => {
  const [cityWithZipcode, location = ''] = address.split('@');
  const [name, zipcode = ''] = cityWithZipcode.split('+');
  const [latitude, longitude] = location.split(',');
  if (name && parseFloat(latitude) && parseFloat(longitude)) {
    return {
      name,
      zipcode,
      location: { latitude: parseFloat(latitude), longitude: parseFloat(longitude) },
    };
  }
  return undefined;
};
